import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  PAGE_META_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

// Phase 3.1 — single-doc editor for `type: 'slide'` filters (the homepage
// hero slider). Slides expose the image (coverPhoto + alt), heading /
// subheading / CTA copy, and the `order` integer that controls render order.
// Static-page metadata, homepage CMS fields, and LocalBusiness fields are
// hidden — those exist on `type: 'page'` docs, not on slides.
const Slide = function () {
  return (
    <AbstractDocument
      singleCollectionName="Slide"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'images',
        'videos',
        'content',
        'contentAr',
        'title',
        'titleAr',
        'publishedAt',
        'scheduledFor',
        ...PAGE_META_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
    />
  )
}
export default Slide
